export default __webpack_public_path__ + "static/media/system-volume-05.bf3c31fd.svg";